import { PaymentFlow } from "@grandvisionhq/payments";
import { CLEAR_PAYMENT_FLOW, SET_PAYMENT_FLOW, UPDATE_PAYMENT_DETAILS, SELECT_PAYMENT_METHOD } from "./actions.js";
const initialState = {
  paymentDetails: {},
  paymentFlow: PaymentFlow.UNDEFINED
};
function paymentReducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_PAYMENT_METHOD:
      return {
        ...state,
        paymentDetails: {},
        selectedPaymentMethod: {
          ...action.payload
        }
      };
    case UPDATE_PAYMENT_DETAILS:
      const { type, provider, data, info, result, isValid } = action.payload;
      return {
        ...state,
        paymentDetails: {
          ...state.paymentDetails,
          [provider]: { type, data, info, result, isValid }
        }
      };
    case SET_PAYMENT_FLOW:
      return { ...state, paymentFlow: action.payload.paymentFlow };
    case CLEAR_PAYMENT_FLOW:
      return { ...state, paymentFlow: PaymentFlow.UNDEFINED };
    default:
      return state;
  }
}
export {
  paymentReducer as default,
  initialState
};
//# sourceMappingURL=reducer.js.map
